import cls from 'classnames';
import moment from 'moment';

import React, { Component, Fragment } from 'react';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import {
    ActionBarButton,
    CancelButton,
    ConfirmButton,
} from 'skrit-web-framework/components/buttons';
import Button from 'skrit-web-framework/components/buttons-new/Button';
import ByteImage from 'skrit-web-framework/components/ByteImage';
import SelectSKR from 'skrit-web-framework/components/selects/SelectSKR';
import { ESTADOS_FORM, SERVER } from 'skrit-web-framework/constantes';
import Ficha from 'skrit-web-framework/fichas';
import translate from 'skrit-web-framework/translator';
import { formatCurrency, smartFetch, swalMsg } from 'skrit-web-framework/utils';
import CounterInput from '../../components/inputs/CounterInput';
import { ACCIONES_CESTA, FICHAS } from '../../utils/ConstantesComunes';

const mapStateToProps = (state) => {
    return {
        ...state.motoscat,
    };
};

const MAXIMO = 500;

class AnyadirArticulo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            articulo: null,
            cesta: [],
            cantidad: 1,
            cantidadMaxima: 1,
            openFichaStock: false,
            openFichaEscalados: false,
            almacenSel: null,
            disableCargar: false,
            modalImage: {
                open: false,
                refSkrit: null,
            },
            numEscalados: 0,
        };
    }

    componentDidMount() {
        if (this.props.reg && this.props.reg != null) {
            this.getAlmacenes();
            return;
        }
    }

    //Funcion that call to the API to get the stores
    getAlmacenes() {
        const { reg } = this.props;
        let codigo = reg.ART_CODIGO;
        smartFetch('/Articulos/GetDesgloseStockArticulo', {
            method: 'POST',
            body: {
                ReferenciaERP: codigo,
            },
        })
            .then(({ body }) => {
                if (body.Ok) {
                    let almacenes = body.Almacenes.map((almacen) => {
                        return {
                            ...almacen,
                            Id: almacen.Codigo,
                            Text: almacen.Descripcion,
                            ArticulosCesta: 0,
                        };
                    });
                    let almacenSel = almacenes[0].Id;
                    let cantidadMaxima = almacenes[0].StockTotal;
                    if (reg.PermitirComprarStockCero) {
                        cantidadMaxima = MAXIMO;
                    }
                    this.setState(
                        {
                            articulo: {
                                ...reg,
                                Almacenes: almacenes,
                            },
                            almacenSel,
                            cantidadMaxima,
                        },
                        () => this.getEscalado()
                    );
                    return;
                }
                this.setState({ isFetching: false }, () =>
                    swalMsg('error', body.MsgError)
                );
            })
            .catch((ex) =>
                this.setState({ isFetching: false }, () => swalMsg('error', ex))
            );
    }

    //Funcion that call to the API to get the price escalation
    getEscalado() {
        let codigo = this.props.reg.ART_CODIGO;
        let cliente = this.props.cliente;
        let almacen = cliente != null ? cliente.ALMACEN_PRE : '';
        let centro =
            cliente != null && cliente.CENTRO != null
                ? cliente.CENTRO.CODIGO
                : '';
        smartFetch('/Articulos/GetEscaladoPreciosArticulo', {
            method: 'POST',
            body: {
                ReferenciaERP: codigo,
                Cliente: cliente != null ? cliente.CODIGO : '',
                Almacen: almacen,
                Centro: centro,
            },
        })
            .then(({ body }) => {
                if (body.Ok) {
                    const escalados = body.Escalado;
                    this.setState((prevState) => ({
                        articulo: {
                            ...prevState.articulo,
                            Escalado: escalados,
                            numEscalados: escalados.length,
                        },
                        isFetching: false,
                    }));
                    return;
                }
                this.setState({ isFetching: false }, () =>
                    swalMsg('error', body.MsgError)
                );
            })
            .catch((ex) =>
                this.setState({ isFetching: false }, () => swalMsg('error', ex))
            );
    }

    //Devuelve un objeto con el precio / descuento / neto del articulo seleccionado dependiendo de su escalado
    getPrecioEscalado(cantidad) {
        const { articulo } = this.state;
        let ret = {
            precio: 0,
            dto: 0,
            neto: 0,
        };
        let escalado = articulo.Escalado;
        //Ordenamos el escalado de precios por su cantidad
        escalado = escalado.sort((a, b) => a - b);
        //Buscamos el precio aplicando su escalado
        for (let index = 0; index < escalado.length; index++) {
            if (escalado[index].cantidad === cantidad) {
                ret.precio = escalado[index].Precio;
                ret.dto = escalado[index].Dto;
                ret.neto = escalado[index].Neto;
                break;
            } else if (escalado[index].Cantidad > cantidad) {
                ret.neto =
                    index !== 0 ? escalado[index - 1].Neto : escalado[0].Neto;
                ret.precio =
                    index !== 0
                        ? escalado[index - 1].Precio
                        : escalado[0].Precio;
                ret.dto =
                    index !== 0 ? escalado[index - 1].Dto : escalado[0].Dto;
                break;
            } else if (index === escalado.length - 1) {
                ret.precio = escalado[index].Precio;
                ret.dto = escalado[index].Dto;
                ret.neto = escalado[index].Neto;
            }
        }
        return ret;
    }

    //Añade el articulo a la cesta
    addArticulo() {
        const { articulo, cantidad, cesta, almacenSel } = this.state;
        let almacen = articulo.Almacenes.find(
            (element) => element.Id === almacenSel
        );
        let indexCesta = cesta.findIndex(
            (element) => element.idAlmacen === almacen.Id
        );
        //Calculamos la cantidad del escalado de precios
        let cantidadEscalado = cantidad;
        if (indexCesta !== -1) {
            cantidadEscalado = cesta[indexCesta].cantidad + cantidad;
        }
        let precios = this.getPrecioEscalado(cantidadEscalado);
        //Creamos un objeto de articulo cesta
        let articuloCesta = {
            cantidad,
            almacen: almacen.Text,
            precio: precios.precio,
            dto: precios.dto,
            neto: precios.neto,
            total: precios.neto * cantidadEscalado,
            idAlmacen: almacen.Id,
        };
        //Insertamos el articulo en la cesta
        if (indexCesta !== -1) {
            articuloCesta = {
                ...articuloCesta,
                cantidad: articuloCesta.cantidad + cesta[indexCesta].cantidad,
            };
            cesta[indexCesta] = articuloCesta;
        } else {
            cesta.push(articuloCesta);
        }
        //Modificamos el stock en la cesta
        let stock = articulo.Almacenes.map((element) => {
            if (element.Id === almacen.Id) {
                return {
                    ...element,
                    ArticulosCesta: articuloCesta.cantidad,
                };
            }
            return element;
        });
        let articuloStock = stock.find((element) => element.Id === almacen.Id);
        let cantidadMaxima = MAXIMO;
        let disableCargar = false;
        if (!articulo.PermitirComprarStockCero) {
            cantidadMaxima =
                articuloStock.StockTotal <= 0
                    ? 1
                    : articuloStock.StockTotal - articuloStock.ArticulosCesta;
            disableCargar =
                articuloStock.ArticulosCesta === articuloStock.StockTotal;
        }
        this.setState({
            cesta,
            articulo: { ...articulo, stock },
            cantidad: 1,
            cantidadMaxima,
            disableCargar,
        });
    }

    handleStock(almacen, changeAlmacen) {
        const { articulo } = this.state;
        let cantidadMaxima = 1;
        let disableCargar = false;
        let almacenSel = null;
        if (articulo.PermitirComprarStockCero) {
            cantidadMaxima = MAXIMO;
            almacenSel = almacen.Id;
        } else if (changeAlmacen) {
            cantidadMaxima =
                almacen.StockTotal <= 0
                    ? 1
                    : almacen.StockTotal - almacen.ArticulosCesta;
            disableCargar = almacen.ArticulosCesta === almacen.StockTotal;
            almacenSel = almacen.Id;
        } else {
            cantidadMaxima = this.state.cantidadMaxima;
            disableCargar = this.state.disableCargar;
            almacenSel = this.state.almacenSel;
        }
        this.setState({
            cantidad: 1,
            cantidadMaxima,
            disableCargar,
            almacenSel,
        });
    }

    handleAccept() {
        const { cesta, articulo } = this.state;
        const { cliente } = this.props;
        let centro = Object.keys(cliente).length === 0 ? null : cliente.CENTRO; // TODO FIX NO CENTRO
        let reg = cesta.map((element, index) => {
            let almacen = articulo.Almacenes.find(
                (almacen) => almacen.Id === element.idAlmacen
            );
            return {
                ...element,
                Linea: index,
                IdCliente: cliente.CODIGO == null ? null : cliente.CODIGO,
                NombreCliente: cliente.RAZON == null ? null : cliente.RAZON,
                CentroCliente: centro != null ? centro.CODIGO : '',
                CodigoAlmacen: almacen.Id,
                FormatoLibre: false,
                DescripcionAlmacen: almacen.Text,
                Descripcion: articulo.ART_DESCRIPCION,
                Referencia: articulo.ART_CODIGO,
                RefComercial: articulo.REFERENCIA_COMERCIAL,
                Marca: articulo.MART_CODIGO,
                NombreMarca: articulo.MART_DESCRIPCION,
                Cantidad: element.cantidad,
                Stock: almacen.StockTotal,
                Precio: element.precio,
                Dto: element.dto,
                Neto: element.neto,
                ComprarSinStock: articulo.PERMITIR_COMPRA_0_STOCK,
                Fecha: moment(new Date()).format('DD/MM/YYYY'),
            };
        });
        let lineas = reg.map((element) => {
            return {
                Accion: ACCIONES_CESTA.ADD,
                Linea: element,
            };
        });
        this.props.accept(lineas);
    }

    handleImage = (refSkrit) => (e) => {
        this.setState({
            modalImage: {
                open: true,
                refSkrit,
            },
        });
    };

    handleCloseModal = (e) => {
        this.setState({
            modalImage: {
                open: false,
                refSkrit: null,
            },
        });
    };

    deleteCestaElement(art) {
        const { cesta, articulo } = this.state;
        let newCesta = [];
        cesta.forEach((element) => {
            if (element.idAlmacen !== art.idAlmacen) {
                newCesta.push(element);
            }
        });
        let almacen = null;
        let newStock = articulo.Almacenes.map((element) => {
            if (element.Id === art.idAlmacen) {
                almacen = {
                    ...element,
                    ArticulosCesta: 0,
                };
                return almacen;
            }
            return element;
        });
        this.setState(
            (prevState) => ({
                cesta: newCesta,
                articulo: { ...prevState.articulo, stock: newStock },
            }),
            () => this.handleStock(almacen, false)
        );
    }

    //--------------------------------- Maquetacion ---------------------------------

    renderModalImage() {
        const { modalImage } = this.state;
        return (
            <Modal
                isOpen={modalImage.open}
                className={cls('modal-dialog modal-image')}
                contentLabel='Modal'
                overlayClassName='modal-overlay'
                onRequestClose={this.handleCloseModal}
                ariaHideApp={false}
                shouldCloseOnEsc
                shouldCloseOnOverlayClick={false}
            >
                <div>
                    <div
                        style={{
                            backgroundColor: '#e8eaed',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'end',
                        }}
                    >
                        <Button
                            icon
                            iconCls={'ms-Icon ms-Icon--Cancel icon'}
                            onClick={this.handleCloseModal}
                        />
                    </div>
                    <div>
                        <ByteImage
                            class='img-fluid'
                            src={`${SERVER}/Articulos/GetImagenERP/${modalImage.refSkrit}/0/1/0/0`}
                            default={'/Styles/img/default-img.svg'}
                        />
                    </div>
                </div>
            </Modal>
        );
    }

    buildContent() {
        const { articulo } = this.state;
        if (articulo == null) return <div />;
        return (
            <Fragment>
                <div className='row articulo-header'>
                    <div className='col-12 col-lg-3'>
                        <ByteImage
                            src={`${SERVER}/Articulos/GetImagenERP/${articulo.ART_CODIGO}/0/1/0/0`}
                            default={'/Styles/img/default-img.svg'}
                            onClick={this.handleImage(articulo.ART_CODIGO)}
                        />
                    </div>
                    <div className='col-12 col-lg-9 articulo-desc'>
                        <span className='articulo-title'>
                            {articulo.DESCRIPCION}
                        </span>
                        <span className='articulo-codigo'>
                            {translate('codigo')}: {articulo.ART_CODIGO}
                        </span>
                    </div>
                </div>
                <div className='row almacenes-row align-items-center my-3'>
                    <div className='label-row'>
                        {translate('stock_almacenes')}
                    </div>
                    <div className='buttons-row'>
                        <ActionBarButton
                            icon
                            iconCls='ms-Icon ms-Icon--POISolid'
                            onClick={() =>
                                this.setState({ openFichaStock: true })
                            }
                            class={cls('btn-rounded semaforo', {
                                verde: articulo.STOCK_ALMACEN > 0,
                                ambar:
                                    articulo.STOCK_ALMACEN <= 0 &&
                                    articulo.STOCK > 0,
                                rojo:
                                    articulo.STOCK_ALMACEN <= 0 &&
                                    articulo.STOCK <= 0,
                            })}
                        />
                    </div>
                </div>
                <div
                    className={cls('row escalado-row align-items-center my-3', {
                        'd-none': this.state.numEscalados <= 1,
                    })}
                >
                    <div className='label-row'>
                        {translate('escalado_precios')}
                    </div>
                    <div className='buttons-row'>
                        <ActionBarButton
                            icon
                            iconCls='ms-Icon ms-Icon--BIDashboard'
                            onClick={() =>
                                this.setState({ openFichaEscalados: true })
                            }
                            class='btn-rounded'
                        />
                    </div>
                </div>
                <div className='row cesta-row'>{this.buildCesta()}</div>
                <div className='row align-items-center flex-nowrap justify-content-around pt-3 selectskr-no-margin'>
                    {this.buildInputsCesta()}
                </div>
            </Fragment>
        );
    }

    buildCesta() {
        const { cesta } = this.state;
        return (
            <Fragment>
                <div className='col-12'>
                    <table className='table table-striped table-hover table-responsive-lg'>
                        <thead>
                            <tr>
                                <th>{translate('cantidad')}</th>
                                <th>{translate('almacen')}</th>
                                <th>{translate('precio')}</th>
                                <th>{translate('dto')}</th>
                                <th>{translate('total')}</th>
                                <th />
                            </tr>
                        </thead>
                        <tbody>
                            {cesta.map((articulo, index) => {
                                return (
                                    <tr key={index}>
                                        <td> {articulo.cantidad} </td>
                                        <td> {articulo.almacen} </td>
                                        <td>
                                            {formatCurrency(articulo.precio)}
                                        </td>
                                        <td>
                                            {formatCurrency(
                                                articulo.dto,
                                                2,
                                                '%'
                                            )}
                                        </td>
                                        <td>
                                            {formatCurrency(articulo.total)}
                                        </td>
                                        <td>
                                            <ActionBarButton
                                                icon
                                                iconCls='ms-Icon ms-Icon--Cancel'
                                                onClick={() =>
                                                    this.deleteCestaElement(
                                                        articulo
                                                    )
                                                }
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </Fragment>
        );
    }

    buildInputsCesta() {
        const { articulo, cantidad, cantidadMaxima, disableCargar } =
            this.state;
        if (articulo == null) return null;
        return (
            <Fragment>
                <div className='select-motoscat-wrapper mr-3'>
                    <SelectSKR
                        options={articulo.Almacenes.map((element) => {
                            return {
                                ...element,
                                id: element.Id,
                                text: element.Text,
                                stockTotal: element.StockTotal,
                                articulosCesta: element.ArticulosCesta,
                            };
                        })}
                        value={this.state.almacenSel}
                        onChange={(value) => {
                            this.handleStock(value, true);
                        }}
                    />
                </div>
                <div className='mr-1'>
                    <CounterInput
                        value={cantidad}
                        min={1}
                        max={cantidadMaxima}
                        handleChange={(value) =>
                            this.setState({
                                cantidad: value,
                            })
                        }
                        focus
                    />
                </div>
                <Button
                    label={translate('anyadir')}
                    onClick={() => this.addArticulo()}
                    disabled={disableCargar}
                />
            </Fragment>
        );
    }

    fichaStock() {
        const { openFichaStock, articulo } = this.state;
        if (articulo == null) return null;
        return (
            <Ficha
                ficha={FICHAS.STOCK_ALMACENES}
                width={'500px'}
                open={openFichaStock}
                estado={ESTADOS_FORM.CONSULTA}
                reg={articulo.ART_CODIGO}
                cancel={() =>
                    this.setState({
                        openFichaStock: false,
                    })
                }
            />
        );
    }

    fichaEscalados() {
        const { openFichaEscalados, articulo } = this.state;
        if (articulo == null) return null;
        return (
            <Ficha
                ficha={FICHAS.ESCALADO_PRECIOS}
                width={'500px'}
                open={openFichaEscalados}
                estado={ESTADOS_FORM.CONSULTA}
                reg={articulo.ART_CODIGO}
                cancel={() =>
                    this.setState({
                        openFichaEscalados: false,
                    })
                }
            />
        );
    }

    render() {
        return (
            <Fragment>
                <div className='page-header'>
                    <div className='title'>
                        <i className='ms-Icon ms-Icon--Search  icon-lg' />
                        <h4>{translate('add_articulo_cesta')}</h4>
                    </div>
                    <div className='actions'>
                        <ConfirmButton onClick={() => this.handleAccept()} />
                        <CancelButton onClick={this.props.cancel} />
                    </div>
                </div>
                <div
                    className='content articulo-cesta'
                    style={{ backgroundColor: '#f9f9f9' }}
                >
                    {this.buildContent()}
                    {this.fichaStock()}
                    {this.fichaEscalados()}
                    {this.renderModalImage()}
                </div>
            </Fragment>
        );
    }
}

export default connect(mapStateToProps, null)(AnyadirArticulo);
